import { DocumentNode } from 'graphql';
import { QueryKey } from '../types/QueryKey';

/**
 * Takes a GraphQL DocumentNode and a literal key, and returns the DocumentNode augmented with that
 * key. This is used to associate a GraphQL query with a fallback key for loading fallback data by
 * `usePimcoreFallback()` hook.
 */
export function queryWithFallbackKey<Q extends DocumentNode, K extends QueryKey>(
    query: Q,
    key: K
): Q & { readonly fallbackKey: K } {
    (query as any).fallbackKey = key;
    return query as Q & { readonly fallbackKey: K };
}
